import { all_routes } from "../../../feature-module/router/all_routes";

const getModuleLink = (checkId: string) => {
  switch (checkId) {
    case "76626fce-8141-4106-86d2-6c1e274adae9":
      return {
        link: `${all_routes.superAdminDashboard}?module=adharvalidation`,
        isDynamic: false,
      };

    case "a687f91f-1c4c-4761-a4fe-37a564887783":
      return {
        link: `${all_routes.superAdminDashboard}?module=firstEducationForm`,
        isDynamic: false,
      };

    case "550f294a-257d-4b87-a0e7-8b34a3223d41":
      return {
        link: `${all_routes.superAdminDashboard}?module=lastTwoEducation`,
        isDynamic: false,
      };

    case "1d479262-b776-4bb5-8e52-3a6919556f5d":
      return {
        link: `${all_routes.superAdminDashboard}?module=educationDocuments`,
        isDynamic: false,
      };

    case "66b2e258-615e-4998-b51b-b8b7ec5a2417":
      return {
        link: `${all_routes.superAdminDashboard}?module=educationDocuments`,
        isDynamic: false,
      };

    case "b225216b-ec67-4b70-a4f0-61ce4460b8bb":
      return {
        link: `${all_routes.superAdminDashboard}?module=employeeForm`,
        isDynamic: false,
      };

    case "1f12f689-b17a-409b-b433-bc7d685ca84f":
    case "2c825e1d-10d2-4caf-b12d-b1df9c21b806":
    case "1eda7972-29b4-40d4-a688-44a3afc2c360":
    case "d904e066-1c35-4525-b971-7aaaa8cbde44":
    case "a0057787-887b-4d45-9da3-5a758e4b6964":
      return {
        link: `${all_routes.superAdminDashboard}?module=employmentHistory`,
        isDynamic: false,
      };

    case "8ff47bc3-a23c-455a-9970-4fff6a685edd":
      return {
        link: `${all_routes.superAdminDashboard}?module=pancardForm`,
        isDynamic: false,
      };

    case "12c919a4-0f58-404a-b147-5a8aea9ab00b":
      return {
        link: `${all_routes.superAdminDashboard}?module=pancardWithoutValidation`,
        isDynamic: false,
      };
    case "39f7eec6-874a-48d8-8c16-4c682269631c":
      return {
        link: `${all_routes.superAdminDashboard}?module=careerGapComments`,
        isDynamic: false,
      };
    case "a65ad58f-7e33-4caf-b289-40520159d251":
      return {
        link: `${all_routes.superAdminDashboard}?module=reference`,
        isDynamic: false,
      };

    default:
      return {
        link: all_routes.dynamicCheck,
        isDynamic: true,
      };
  }
};

const ALLOWED_CHECK_IDS = [
  "76626fce-8141-4106-86d2-6c1e274adae9", // Aadhar KYC
  "a687f91f-1c4c-4761-a4fe-37a564887783", // Highest Education
  "550f294a-257d-4b87-a0e7-8b34a3223d41", // 2 Highest Education
  "1d479262-b776-4bb5-8e52-3a6919556f5d", // Education Documents
  "66b2e258-615e-4998-b51b-b8b7ec5a2417", // All Education Documents
  "b225216b-ec67-4b70-a4f0-61ce4460b8bb", // Employement
  "1f12f689-b17a-409b-b433-bc7d685ca84f", // Employement 2 YEAR
  "2c825e1d-10d2-4caf-b12d-b1df9c21b806", // Employement 3 YEAR
  "1eda7972-29b4-40d4-a688-44a3afc2c360", // Employement 5 YEAR
  "d904e066-1c35-4525-b971-7aaaa8cbde44", // Employement 7 YEAR
  "a0057787-887b-4d45-9da3-5a758e4b6964", // Employement 10 YEAR
  "8ff47bc3-a23c-455a-9970-4fff6a685edd", // Pancard
  "12c919a4-0f58-404a-b147-5a8aea9ab00b", // PAN card verification (without validation)
  "39f7eec6-874a-48d8-8c16-4c682269631c", // Career Gap Comments
  "a65ad58f-7e33-4caf-b289-40520159d251", // Reference
];

export const buildCheckMenuItems = (templates: any[]) => {
  return templates
    .filter((item) => ALLOWED_CHECK_IDS.includes(item.check_id)) // <-- Only these 4
    .sort((a, b) => (a.display_order ?? 999) - (b.display_order ?? 999))
    .map((item) => {
      const route = getModuleLink(item.check_id);

      return {
        label:
          item.check_name === "PAN card verification (without validation)"
            ? "PAN Card – No Val."
            : item.check_name,

        link: route.link,
        isDynamic: route.isDynamic,

        assignment_template_id: item.assignment_template_id,
        assignment_id: item.assignment_id,
        case_id: item.case_id,
        check_name: item.check_name,

        completed: item.status,

        icon: "user-shield",
        base: "companies",
        materialicons: "shopping_bag",
      };
    });
};

export const sidebarData = (templates: any[], packageStatus: any) => {
  // Get actual Address Verification check from API templates
  const addressCheck = templates?.find(
    (item) => item.check_id === "9a6fd659-63ad-4d92-ad3c-ab5bff7bb86d",
  );

  return [
    {
      tittle: "",
      icon: "file",
      showAsTab: false,
      separateRoute: false,
      submenuItems: [
        {
          label: "Dashboard",
          submenu: false,
          link: `${all_routes.caseSummary}`,
          showSubRoute: false,
          icon: "layout-dashboard",
          base: "super-admin-dashboard",
          materialicons: "confirmation_number",
          submenuItems: [],
        },
        {
          label: "Step-1 (Personal Detail)",
          submenu: true,
          showSubRoute: true,
          icon: "timeline",
          base: "super-admin-dashboard",
          materialicons: "confirmation_number",
          submenuItems: [
            {
              label: "Personal Information",
              link: `${all_routes.superAdminDashboard}`,
              icon: "user-shield",
              base: "companies",
              materialicons: "shopping_bag",
              completed: true,
            },

            ...(addressCheck
              ? [
                  {
                    label: "Address Information",
                    link: `${all_routes.addressInfo}`,
                    icon: "user-shield",
                    base: "companies",
                    materialicons: "shopping_bag",
                    completed: addressCheck.status,
                  },
                ]
              : []),
          ],
        },
        {
          label: "Step-2 (Check Detail)",
          submenu: true,
          showSubRoute: false,
          icon: "user-shield",
          base: "companies",
          materialicons: "shopping_bag",
          submenuItems: buildCheckMenuItems(templates),
        },
        {
          label: "Step-3 (Consent Form)",
          submenu: true,
          showSubRoute: true,
          icon: "file-check",
          base: "subscriptions",
          materialicons: "account_balance_wallet",
          submenuItems: [
            {
              label: "Authorization",
              link: `${all_routes.superAdminDashboard}?module=authorization`,
              icon: "user-shield",
              base: "companies",
              materialicons: "shopping_bag",
              completed: packageStatus,
            },
          ],
        },
      ],
    },
  ];
};
